module.exports = __webpack_public_path__ + "img/67.c03f1d20.jpg";